import { Link, Redirect } from 'react-router-dom'
import { Stack, Card, Icon } from '@leroy-merlin-br/backyard-react'
import { ChevronLeftOutline } from '@backyard-ui/icons'

import { Breadcrumb, Collapse } from 'lmcv/components'
import { CATEGORY_ICONS } from 'lmcv/components/NewFaqList/categoryIcons'
import { FAQ_DATA } from 'lmcv/components/NewFaqList/constants'

import * as S from './styled'

const FaqCategory = ({
  match: {
    params: { categorySlug }
  }
}) => {
  const category = FAQ_DATA.find(({ slug }) => slug === categorySlug)

  if (!category) {
    return <Redirect to="/duvidas" />
  }

  return (
    <Stack>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/duvidas">
            <ChevronLeftOutline width={16} height={16} fill="currentColor" />{' '}
            Dúvidas
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{category.category}</Breadcrumb.Item>
      </Breadcrumb>

      <Card
        title={
          <S.CategoryTitle>
            <Icon
              as={CATEGORY_ICONS[category.slug]}
              size="mega"
              color="primary"
            />
            {category.category}
          </S.CategoryTitle>
        }>
        {category.questions.map(({ title, text }, index) => (
          <Collapse
            key={index}
            titleNumber={index + 1}
            title={title}
            content={text}
          />
        ))}
      </Card>
    </Stack>
  )
}

export default FaqCategory
